export const GET_ALL_REPORTS_RESULT = "GET_ALL_REPORTS_RESULT";
export const START_LOADING_REPORTS_RESULT = "START_LOADING_REPORTS_RESULT";
export const ERROR_LOADING_REPORTS_RESULT = "ERROR_LOADING_REPORTS_RESULT";
export const STOP_LOADING_REPORTS_RESULT = "STOP_LOADING_REPORTS_RESULT";
export const RESET_DATA = "RESET_DATA";
